<template>
  <div
    style="display: inline-block; vertical-align: top; position: relative"
    class="mr-4 move-left-item"
  >
    <v-btn
      icon
      class="ma-3"
      :to="`/garden/${plant.userId}`"
      style="position: absolute; top: 0; left: 0; z-index: 2"
      ><v-img
        class="shrink rounded-circle"
        :src="plant.userProfilePictureUrl"
        transition="fade-transition"
        height="40"
        width="40"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-icon
              size="24"
              color="white"
              style="text-shadow: 0px 0px 2px rgba(150, 150, 150, 1)"
              >mdi-account-outline</v-icon
            >
          </v-row>
        </template>
      </v-img></v-btn
    >

    <div
      v-if="plant.loversId"
      style="
        position: absolute;
        right: 0px;
        bottom: 0px;
        padding-right: 16px;
        padding-bottom: 9px;
        z-index: 2;
      "
      @click="
        $emit(
          'toggleLove',
          {
            itemId: plant.id,
            parentId: plant.userId,
            target: 'plants',
            self,
            deep: true,
          },
          plant
        )
      "
    >
      <span class="white--text text-h6 mr-1">{{ plant.loversId.length }}</span>
      <v-icon
        class="mb-1"
        :color="plant.loversId.includes(self.id) ? 'error' : 'white'"
        >{{
          plant.loversId.includes(self.id) ? "mdi-heart" : "mdi-heart-outline"
        }}</v-icon
      >
    </div>

    <v-img
      class="shrink rounded-xl"
      :src="plant.pictureUrl"
      transition="scale-transition"
      style="position: relative"
      width="160"
      height="240"
      @click="$router.push(`/garden/${plant.userId}/plant/${plant.id}`)"
      ><template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-row>
      </template>
      <div
        v-if="plant.numberOfComments"
        style="
          position: absolute;
          z-index: 2;
          left: 16px;
          bottom: 9px;
          text-shadow: 0px 0px 2px rgba(150, 150, 150, 1);
        "
        class="white--text text-h6"
      >
        <div class="d-inline-block">{{ plant.numberOfComments }}</div>
        <v-icon
          class="mr-0 ml-1 mt-n1"
          color="white"
          style="text-shadow: 0px 0px 2px rgba(150, 150, 150, 1)"
          >mdi-chat-outline</v-icon
        >
      </div>
    </v-img>
  </div>
</template>

<script>
export default {
  name: "PlantActivity",
  props: ["plant", "self"],
};
</script>
